import React from 'react'
import {connect, ConnectedProps} from 'react-redux'
import {createStructuredSelector} from 'reselect'
import {useLocation} from 'react-router-dom'

import {TRANSACTION_TYPE_BUY, TRANSACTION_TYPE_RENT, TRANSACTION_TYPE_RENT_ADD} from '../../const'
import {CartContext} from '../../contexts/CartContext'
import {isHtoActive} from '../../feature-flags'
import * as pdp from '../../store/productDetailPage'

import {AddItemButton} from '../OrderManager'
import AddToLookButton from './AddToLookButton'
import HtoButton from './HtoButton'
import TransactionTypeButton from './TransactionTypeButton'
import GroomRentsFreePromoBanner from './GroomRentsFreePromoBanner'

import RentThisItemInstead from './RentThisItemInstead'

interface Props extends PropsFromRedux {
  showBuyPathExperiment?: boolean
  productCategorySlug: string
  isKit?: boolean
}

export const AddToLook = ({
  productIsKitOrGroup,
  productCategorySlug,
  showBuyPathExperiment = false,
  isKit = false,
}: Props): JSX.Element => {
  const {pathname} = useLocation()
  const {isActive: isCartActive} = React.useContext(CartContext)

  const isHTOPath = !!pathname.match(/home-try-on/) // I don't love this
  const isSuitsTuxedos = ['tuxedos', 'suits'].includes(productCategorySlug)
  const isShirtsVestsNeckwear = ['shirts', 'vests', 'neckwear-2'].includes(productCategorySlug)
  const isHtoCategory = isSuitsTuxedos || isShirtsVestsNeckwear

  if (showBuyPathExperiment) {
    return (
      <>
        <div style={{paddingBottom: 30}}>
          <TransactionTypeButton
            transactionType={TRANSACTION_TYPE_BUY}
            showBuyPathExperiment={showBuyPathExperiment}
          />
        </div>
        <AddToLookButton
          buttonText={productIsKitOrGroup ? 'Customize Look' : 'Add to Look'}
          showBuyPathExperiment={showBuyPathExperiment}
        />
        <RentThisItemInstead to={pathname.split('/buy')[0]} />
      </>
    )
  }

  if (isHtoActive && isHtoCategory && isHTOPath) {
    return (
      <>
        <HtoButton />
        <RentThisItemInstead to={pathname.split('/home-try-on')[0]} />
      </>
    )
  }

  return (
    <div className="product-add-to-look">
      <h2>
        <span className="product-add-to-look-num">1</span>
        Choose Order Type
      </h2>

      {isCartActive ? (
        <TransactionTypeButton transactionType={TRANSACTION_TYPE_RENT_ADD} />
      ) : (
        <>
          <TransactionTypeButton transactionType={TRANSACTION_TYPE_RENT} />
          <TransactionTypeButton transactionType={TRANSACTION_TYPE_BUY} />
        </>
      )}

      <h2>
        <span className="product-add-to-look-num">2</span>
        Select a Look
      </h2>

      {isCartActive ? (
        <AddItemButton />
      ) : (
        <AddToLookButton buttonText={productIsKitOrGroup ? 'Customize Look' : 'Add to Look'} />
      )}

      {isKit && <GroomRentsFreePromoBanner showBuyPathExperiment={showBuyPathExperiment} />}

      {isHtoActive && isShirtsVestsNeckwear && (
        <div className="product-hto-button">
          <HtoButton />
        </div>
      )}
    </div>
  )
}

const mapStateToProps = createStructuredSelector({
  productIsKitOrGroup: pdp.productIsKitOrGroup,
  productCategorySlug: pdp.productCategorySlug,
})

const connector = connect(mapStateToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(AddToLook)
